import { Reducer } from 'redux';
import { AuditActionEnum, AuditActions, IAuditState } from '.';
import {
  IAuditLog
} from '../../services';

export const initialState: IAuditState = {
  loading: true,
  auditLog: {} as IAuditLog,
  exceptionMessage: "",
  isPosAuditSuccess: false,
};

export const auditReducer: Reducer<IAuditState, AuditActions> = (
    state = initialState,
  action: AuditActions
) => {
  switch (action.type) {
    case AuditActionEnum.PostAudit:
        return {
          ...state,
          loading: true,
          message:"",
          isPostExchangeConfigSuccess: false
      };
    case AuditActionEnum.PostAuditSuccess:
        return {
          ...state,
          loading: false,
          message: "",
          isPostExchangeConfigSuccess: true
      };
    case AuditActionEnum.PostAuditFailed:
        return {
          ...state,
          loading: false,
          message: action.state?.exceptionMessage,
          isPostExchangeConfigSuccess: false
        };
    default:
      return state;
  }
};
